export default __webpack_public_path__ + "static/Forecast your wage bill ahead of payday to avoid unwanted surprises@2x-986d1b54a56717688ab18dd8bb3cd7b0.png";